import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Restaurants({color, classes = '', url}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg fill={color} width="18" height="18" viewBox="0 0 15 15" id="restaurant-noodle" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.457,11.9892,1,8V7H14V8l-3.4961,3.9891ZM3.9882,2.5a.5.5,0,0,0-1,0v.5671l-1.7969.3675a.25.25,0,1,0,.094.4911l1.7029-.2776v.5662l-1.75.0357a.25.25,0,0,0,0,.5l1.75.0357V5.998h1Zm9.5,1.5-7.5.2625V2.9951l7.594-1.0737a.5.5,0,0,0-.1881-.9822L5.9792,2.4555a.4963.4963,0,0,0-.991.0445v.2276l-.493.1009V3.18l.493-.08V4.2974l-.493.01v.4608L13.4882,5a.5.5,0,0,0,0-1ZM10,13H5v.5757h5Z"/>
            </svg>
        </div>
    );
}

export default Restaurants;
